import axios from 'axios'
import { ICrudDeleteAction, ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudSearchAction } from 'react-jhipster'

import { cleanEntity } from '../../../utils/entity-utils'
import { FAILURE, REQUEST, SUCCESS } from '../action-type.util'

import { defaultValue, INationality } from '../../model/nationality.model'

export const ACTION_TYPES = {
  SEARCH_NATIONALITIES: 'nationality/SEARCH_NATIONALITIES',
  FETCH_NATIONALITY_LIST: 'nationality/FETCH_NATIONALITY_LIST',
  FETCH_NATIONALITY: 'nationality/FETCH_NATIONALITY',
  CREATE_NATIONALITY: 'nationality/CREATE_NATIONALITY',
  UPDATE_NATIONALITY: 'nationality/UPDATE_NATIONALITY',
  DELETE_NATIONALITY: 'nationality/DELETE_NATIONALITY',
  SET_BLOB: 'nationality/SET_BLOB',
  RESET: 'nationality/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<INationality>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type NationalityState = Readonly<typeof initialState>;

// Reducer

export default (state: NationalityState = initialState, action): NationalityState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.SEARCH_NATIONALITIES):
    case REQUEST(ACTION_TYPES.FETCH_NATIONALITY_LIST):
    case REQUEST(ACTION_TYPES.FETCH_NATIONALITY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_NATIONALITY):
    case REQUEST(ACTION_TYPES.UPDATE_NATIONALITY):
    case REQUEST(ACTION_TYPES.DELETE_NATIONALITY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.SEARCH_NATIONALITIES):
    case FAILURE(ACTION_TYPES.FETCH_NATIONALITY_LIST):
    case FAILURE(ACTION_TYPES.FETCH_NATIONALITY):
    case FAILURE(ACTION_TYPES.CREATE_NATIONALITY):
    case FAILURE(ACTION_TYPES.UPDATE_NATIONALITY):
    case FAILURE(ACTION_TYPES.DELETE_NATIONALITY):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.SEARCH_NATIONALITIES):
    case SUCCESS(ACTION_TYPES.FETCH_NATIONALITY_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_NATIONALITY):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_NATIONALITY):
    case SUCCESS(ACTION_TYPES.UPDATE_NATIONALITY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_NATIONALITY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.SET_BLOB: {
      const { name, data, contentType } = action.payload;
      return {
        ...state,
        entity: {
          ...state.entity,
          [name]: data,
          [name + 'ContentType']: contentType,
        },
      };
    }
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/nationalities';
const apiSearchUrl = 'api/_search/nationalities';

// Actions

export const getSearchEntities: ICrudSearchAction<INationality> = (query, page, size, sort) => ({
  type: ACTION_TYPES.SEARCH_NATIONALITIES,
  payload: axios.get<INationality>(`${apiSearchUrl}?query=${query}${sort ? `&page=${page}&size=${size}&sort=${sort}` : ''}`),
});

export const getEntities: ICrudGetAllAction<INationality> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_NATIONALITY_LIST,
    payload: axios.get<INationality>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export const getEntity: ICrudGetAction<INationality> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_NATIONALITY,
    payload: axios.get<INationality>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<INationality> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_NATIONALITY,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<INationality> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_NATIONALITY,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<INationality> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_NATIONALITY,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const setBlob = (name, data, contentType?) => ({
  type: ACTION_TYPES.SET_BLOB,
  payload: {
    name,
    data,
    contentType,
  },
});

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
